import { ShieldAlert } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export function ForbiddenPage(): React.ReactElement {
  return (
    <div className="space-y-6">
      <Card className="shadow-none border-border/80">
        <CardHeader>
          <CardTitle className="flex items-center gap-3 text-3xl font-serif text-primary">
            <ShieldAlert className="h-7 w-7 text-destructive" />
            Åtkomst nekad
          </CardTitle>
          <CardDescription>Du har inte behörighet att se den här sidan.</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          <p>Kontakta en administratör om du tror att detta är fel.</p>
        </CardContent>
      </Card>
    </div>
  )
}
